// extracted by mini-css-extract-plugin
module.exports = {"fullWidthMode":"TradeIn_fullWidthMode__1ffgm"};